import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IOption } from '../../interfaces/IOption';
import { IOrder } from '../../interfaces/IOrder';
import { OptionType } from '../../enums/OptionType';

const apiUrl = Globals.apiPath + '/options';

//#region DTOs
export interface ICreateOptionItemDto {
  title: string;
  description?: string | null;
  picture?: string | null;
  cost: number;
  discountedCost: number | null;
  active: boolean;
  index?: number;
}

export interface ICreateOptionDto {
  title: string;
  description?: string | null;
  type: OptionType; // Assuming OptionType is an enum you've defined elsewhere
  main: boolean;
  multiple: boolean;
  mandatory: boolean;
  min: number | null;
  max: number | null;
  optionItems: ICreateOptionItemDto[];
}

export interface ICreateOptionWithRestaurantDto extends ICreateOptionDto {
  restaurantId: number;
  itemId?: number | null;
  menuId?: number | null;
}

export interface IUpdateOptionItemDto extends ICreateOptionItemDto {
  id?: number | null;
  deletedAt?: Date;
}

export interface IUpdateOptionDto extends ICreateOptionDto {
  id: number;
  optionItems: IUpdateOptionItemDto[];
}
//#endregion

export default class OptionsService {
  constructor() {}

  static async getAllUsable(
    restaurantId: number,
    branchId: number,
    type: OptionType | 'all',
    menuId: number | 'all' | null
  ): Promise<IOption[]> {
    let res = await axios.get<IOption[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}&t=${type}` +
        (menuId ? `&m=${menuId}` : '')
    );
    return res.data;
  }

  static async getById(id: number): Promise<IOption> {
    let res = await axios.get<IOption>(`${apiUrl}/${id}`);
    return res.data;
  }

  static async create(dto: ICreateOptionWithRestaurantDto): Promise<IOption> {
    let res = await axios.post<IOption>(`${apiUrl}`, dto);
    return res.data;
  }

  static async update(dto: IUpdateOptionDto): Promise<IOption> {
    let res = await axios.put<IOption>(`${apiUrl}/${dto.id}`, dto);
    return res.data;
  }

  static async delete(id: number): Promise<IOption> {
    const res = await axios.delete<IOption>(`${apiUrl}/${id}`);
    return res.data;
  }
}
